module.exports = __webpack_public_path__ + "static/media/YB5M08_1.1bb82e2c.jpg";